const { FRONTEND_SERVICE_URL: SERVICE_URL, FRONTEND_BUILD_STRING: BUILD_STRING, PROD } = import.meta.env;

if (!SERVICE_URL && PROD) {
  throw new Error('Required environment variable FRONTEND_SERVICE_URL is missing');
}

export const FRONTEND_SERVICE_URL = SERVICE_URL ?? 'http://127.0.0.1:3000';
export const FRONTEND_BUILD_STRING = BUILD_STRING ?? 'Local Development';
